import React, { Component } from 'react'
import { ACTIVE_BRANDS } from '../../../configuration/brands'

class EQuoteSearchFiltersFullFormBrand extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  activeBrands = brands => {
    return brands.filter(brand => !brand.disabled)
  }

  render() {
    const {
      brands,
      currentBrand,
      voyageTypes,
      voyageType,
      handleSelectBrand,
      disabledBrands
    } = this.props

    let filterBrands = brands.filter(brand =>
      ACTIVE_BRANDS.includes(brand.brand_code)
    )
    let typeBrand = []
    let brandTypes = ''
    let selectedBrand = currentBrand

    if (voyageType) {
      typeBrand = voyageTypes.filter(item => item.value === voyageType)

      brandTypes = typeBrand[0].brand

      filterBrands.forEach(item => {
        item.disabled =
          brandTypes.indexOf(item.brand_code) === -1 ||
          (disabledBrands && disabledBrands.includes(item.brand_code))
      })

      const activeBrands = this.activeBrands(filterBrands)
      if (activeBrands.length === 1) {
        selectedBrand = activeBrands[0].brand_code
      }
    } else if (disabledBrands && disabledBrands.length) {
      filterBrands.forEach(item => {
        item.disabled = disabledBrands.includes(item.brand_code)
      })
    }

    return (
      <div className="equote__search-filters-form-field-input u-custom-select fixed-width-200">
        <select
          name="brand"
          onChange={e => handleSelectBrand(e.target.value)}
          value={selectedBrand}
          tabIndex={0}
          aria-labelledby="brandToggleLabel"
        >
          <option
            value="C,R"
            disabled={this.activeBrands(filterBrands).length === 1}
          >
            All Brands
          </option>
          {filterBrands &&
            filterBrands.map(brand => (
              <option
                key={brand.brand_code}
                value={brand.brand_code}
                disabled={brand?.disabled ?? false}
              >
                {brand.name}
              </option>
            ))}
        </select>
        <span className="u-custom-select__arrow" />
      </div>
    )
  }
}

export default EQuoteSearchFiltersFullFormBrand
